import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Checkbox,
  Space,
  Tabs,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
import {
  SelectItem,
  Form,
  FormItem,
  cuentaMask,
  RangePickerItem,
  TableItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem
} from "../../../../Components/Items";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import { ResponsiveBar } from "@nivo/bar"; 
import reporteInsumosMasVendidosPdf from "../../../../Pdf/reporteInsumosMasVendidosPdf";
import moment from "moment";
import "moment/locale/es";
moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
const { TabPane } = Tabs;

class ReporteInsumosMasVendidos extends Component {
  state = {
    loading: false,
    pdf: null,
    objetoClientes: null,
    todasClientes: null,
    objetoUsuarios: null,
    todasUsuarios: null,
    objetoProyectos: null,
    todasProyectos: null,
    objetoUniadesDeNegocio: null,
    todasUniadesDeNegocio: null,
    dataReporte: null,
    todasInsumos: [],
    dataGrafico: [],
    
    // Variables para totales
    piezasVendidas: 0,
    ingresos: 0,
    costos: 0,
    utilidad: 0,
    
    desglosarProductos: false,
    mostrarCostos: false 
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });

    await Promise.all([
      axios.post(
        "clientes/selectClientes",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ).then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasClientes: res.data,
            objetoClientes: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.stringBuscar}
              </Option>
            )),
          });
        }
      }),

      axios.post(
        "usuarios/selectUsuariosEmpresa",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ).then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasUsuarios: res.data,
            objetoUsuarios: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre + " " + value.apellidoPaterno + " " + value.apellidoMaterno}
              </Option>
            )),
          });
        }
      }),

      axios.post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ).then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasProyectos: res.data,
            objetoProyectos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            )),
          });
        }
      }),

      axios.post(
        "unidadesdenegocio/selectUnidadesDeNegocio",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ).then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasUniadesDeNegocio: res.data,
            objetoUniadesDeNegocio: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {cuentaMask(
                  value.nivel1 + value.nivel2 + value.nivel3 +
                  value.nivel4 + value.nivel5
                ) + " - " + value.nombre}
              </Option>
            )),
          });
        }
      }),

      axios.post(
        "canalesVenta/selectCanalesVenta",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ).then((res) => {
        if (res.data.success === 2) {
          this.setState({
            todasCanalesVenta: res.data.canalesVenta || [],
            objetoCanalesVenta: (res.data.canalesVenta || []).map((value) => (
              <Option value={value._id} key={value._id}>
                {value.codigo + " - " + value.nombre}
              </Option>
            )),
          });
        } else {
          message.error("Ha sucedido un error y no se cargaron los canales de venta");
        }
      }),
    ]);

    this.consultarReporteInsumosMasVendidos({
      periodo: [moment().subtract(1, "month"), moment()],
      clientes: 0,
      vendedores: 0,
      filtrarProyecto: 0,
      estadoFacturas: 5,
    });
  }

  crearGraficoBarras(insumos) {
    const top10 = [...insumos].slice(0, 10);
    
    top10.reverse();

    const dataGrafico = top10.map(item => ({
      insumo: (item.clave || 'Sin Clave') + ` (${item.moneda})`,
      "Ingreso Total": item.ingresoTotal || 0,
      "Costo Total": item.costoTotal || 0,
      "Utilidad": item.utilidad || 0,
      descCompleta: item.descripcion 
    }));

    this.setState({ dataGrafico });
  }

  consultarReporteInsumosMasVendidos(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesDeVentas/reporteInsumosMasVendidos",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          
          this.crearGraficoBarras(res.data.insumos);
          
          this.setState({
            loading: false,
            dataReporte: res.data,
            todasInsumos: res.data.insumos,
            piezasVendidas: res.data.totales.cantidad,
            ingresos: res.data.totales.ingresos,
            costos: res.data.totales.costos,
            utilidad: res.data.totales.utilidad,
          });
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
          this.setState({ loading: false });
        }
      })
      .catch(() => {
          message.error("Error de conexión");
          this.setState({ loading: false });
      });
  }

  descargarExcel() {
    let datosDescargar = this.state.todasInsumos.map((item) => {
       let fila = {
          "Clave": item.clave,
          "Código Barras": item.codigoBarras,
          "Descripción": item.descripcion,
          "Familia": item.familia || 'N/A',
          "Marca": item.marca || 'N/A',
          "Tipo de Insumo": item.tipoInsumo || 'N/A',
          "Cantidad Vendida": item.cantidad,
          "Moneda": item.moneda,
          "Precio Unit. Promedio": item.precioUnitario,
          "Ingreso Total": item.ingresoTotal,
        };

        if(this.state.mostrarCostos){
            fila["Costo Total"] = item.costoTotal;
            fila["Utilidad"] = item.utilidad;
        }
        return fila;
      });

    const worksheet = XLSX.utils.json_to_sheet(datosDescargar);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Insumos");
    XLSX.writeFile(workbook, `Insumos_Mas_Vendidos_${moment().locale("es").format("L")}.xlsx`);
  }

  descargarPdf() {
    const datosParaPdf = {
      ...this.state.dataReporte,
      mostrarCostos: this.state.mostrarCostos
    };

    pdfMake
      .createPdf(reporteInsumosMasVendidosPdf(datosParaPdf))
      .download(`Insumos_Mas_Vendidos_${moment().locale("es").format("L")}.pdf`);
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }
  render() {
    let columns = [
      {
        title: "Clave",
        dataIndex: "clave",
        key: "clave",
        buscar: "clave",
        width: "6%",
      },
      {
        title: "Código Barras",
        dataIndex: "codigoBarras",
        key: "codigoBarras",
        buscar: "codigoBarras",
        width: "10%",
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        buscar: "descripcion",
        width: "22%",
        ellipsis: true,
      },
      {
        title: "Familia",
        dataIndex: "familia",
        key: "familia",
        buscar: "familia",
        width: "10%",
      },
      {
        title: "Marca",
        dataIndex: "marca",
        key: "marca",
        buscar: "marca",
        width: "10%",
      },
      {
        title: "Tipo",
        dataIndex: "tipoInsumo",
        key: "tipoInsumo",
        buscar: "tipoInsumo",
        width: "10%",
      },
      {
        title: "Cantidad",
        dataIndex: "cantidad",
        key: "cantidad",
        sorter: (a, b) => a.cantidad - b.cantidad,
        align: "right",
        width: "10%",
      },
      {
        title: "Moneda",
        dataIndex: "moneda",
        key: "moneda",
        width: "8%",
        align: "center",
      },
      {
        title: "Precio Unit.",
        dataIndex: "precioUnitario",
        key: "precioUnitario",
        render: (value) => dineroDisabledMask(value),
        align: "right",
      }
    ];

    if(this.state.mostrarCostos){
        columns.push({
            title: "Costo Total",
            dataIndex: "costoTotal",
            key: "costoTotal",
            sorter: (a, b) => a.costoTotal - b.costoTotal,
            render: (value) => dineroDisabledMask(value),
            align: "right",
        });
    }

    columns.push({
        title: "Ingreso Total",
        dataIndex: "ingresoTotal",
        key: "ingresoTotal",
        sorter: (a, b) => a.ingresoTotal - b.ingresoTotal,
        render: (value) => dineroDisabledMask(value),
        align: "right",
    });

    if(this.state.mostrarCostos){
        columns.push({
            title: "Utilidad",
            dataIndex: "utilidad",
            key: "utilidad",
            sorter: (a, b) => a.utilidad - b.utilidad,
            render: (value) => dineroDisabledMask(value),
            align: "right",
        });
    }

    return (
      <>
        <Form
          ref={this.formRef}
          name="reporteInsumos"
          onFinish={this.consultarReporteInsumosMasVendidos.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().subtract(1, "month"), moment()],
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte Insumos Más Vendidos"
            style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem blanco onClick={() => this.descargarExcel()} icon={<FileExcelOutlined />}>
                      Descargar Excel
                    </ButtonItem>
                  )}
                  {this.state.dataReporte && (
                    <ButtonItem blanco onClick={() => this.descargarPdf()} icon={<FilePdfOutlined />}>
                      Descargar PDF
                    </ButtonItem>
                  )}
                  <ButtonItem type="primary" htmlType="submit">
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            {/* FILTROS */}
            <div style={{ backgroundColor: "white", padding: 20, paddingTop: 5, borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)" }}>
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{ left: <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1> }}
              >
                <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                  <FormItem name="periodo" required noStyle>
                    <RangePickerItem />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="2" key="2" forceRender tab="Clientes">
                  <FormItem name="clientes" noStyle margin>
                    <SelectItem width="90%" mode="multiple" placeholder="Clientes">
                      {this.state.objetoClientes}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="3" key="3" forceRender tab="Vendedores">
                  <FormItem name="vendedores" margin noStyle>
                    <SelectItem width="90%" mode="multiple" placeholder="Vendedores">
                      {this.state.objetoUsuarios}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                  <Row>
                    <Col span={8}>
                      <FormItem name="filtrarProyecto" required noStyle initialValue={0}>
                        <SelectItem width="90%" placeholder="Filtrar Proyecto">
                          <Option default value={0}>Niguno</Option>
                          <Option value={1}>Proyectos</Option>
                          <Option value={2}>Unidades de negocio</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const filtrarProyecto = getFieldValue("filtrarProyecto");
                          if (filtrarProyecto === 1) {
                            return (
                              <FormItem required name="proyectos" margin noStyle>
                                <SelectItem width="90%" placeholder="Proyectos" mode="multiple">
                                  {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                          if (filtrarProyecto === 2) {
                            return (
                              <FormItem required margin name="unidadDeNegocioId" noStyle>
                                <SelectItem width="90%" placeholder="Unidades de Negocio">
                                  {this.state.objetoUniadesDeNegocio}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                        }}
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabKey="6" key="6" forceRender tab="Canales de Venta">
                  <FormItem name="canalesVenta" margin noStyle>
                    <SelectItem width="90%" mode="multiple" placeholder="Canales de Venta">
                      {this.state.objetoCanalesVenta}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="5" key="5" forceRender tab="Opciones">
                  <Row style={{ padding: 0, margin: 0 }} gutter={[16, 0]}>
                    <Col span={12}>
                      <FormItem label="Estado de las Ventas" name="estadoFacturas" required initialValue={5} style={{ marginBottom: 0 }}>
                        <SelectItem placeholder="Filtrar Por">
                          <Option default value={5}>Activas</Option>
                          <Option value={4}>Por Cobrar</Option>
                          <Option value={3}>Cobrada</Option>
                          <Option value={2}>Vencida</Option>
                          <Option value={1}>Canceladas</Option>
                          <Option value={0}>Todas (Activas y Canceladas)</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={12}>
                        <Checkbox 
                            checked={this.state.mostrarCostos} 
                            onChange={(e) => this.setState({mostrarCostos: e.target.checked})}
                        >
                            Mostrar Costos y Utilidad
                        </Checkbox>
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            </div>

            <div style={{ backgroundColor: "white", padding: 20, paddingBottom: 40, marginTop: 10, marginBottom: 10, height: 450, borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)" }}>
              <h1 style={{ fontSize: 18, margin: 0, }}>Top 10 Insumos</h1>
              <ResponsiveBar
                  data={this.state.dataGrafico}
                  keys={this.state.mostrarCostos ? ['Utilidad', 'Costo Total'] : ['Ingreso Total']}
                  indexBy="insumo"
                  margin={{ right: 130, bottom: 50, left: 100 }}
                  padding={0.4} 
                  layout="horizontal"
                  valueScale={{ type: 'linear' }}
                  indexScale={{ type: 'band', round: true }}
                  
                  colors={this.state.mostrarCostos ? ["#28c513", "#1dd6d6"] : ["#1dd6d6"]}
                  
                  borderRadius={3} 
                  borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
                  axisTop={null}
                  axisRight={null}
                  axisBottom={{
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 0,
                      legend: 'Monto ($)',
                      legendPosition: 'middle',
                      legendOffset: 40,
                      format: (v) => `$${v >= 1000 ? (v / 1000) + 'k' : v}` 
                  }}
                  axisLeft={{
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 0,
                      legend: 'Clave Insumo',
                      legendPosition: 'middle',
                      legendOffset: -80
                  }}
                  enableLabel={false} 
                  legends={[
                      {
                          dataFrom: 'keys',
                          anchor: 'bottom-right',
                          direction: 'column',
                          justify: false,
                          translateX: 120,
                          translateY: 0,
                          itemsSpacing: 2,
                          itemWidth: 100,
                          itemHeight: 20,
                          itemDirection: 'left-to-right',
                          itemOpacity: 0.85,
                          symbolSize: 20,
                          symbolShape: 'circle', 
                          effects: [ { on: 'hover', style: { itemOpacity: 1 } } ]
                      }
                  ]}
                  tooltip={({ id, value, color, data }) => (
                      <div style={{ padding: '10px 14px', background: '#fff', border: '1px solid #e2e8f0', borderRadius: '6px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                          <strong style={{ fontSize: '13px' }}>{data.insumo} - {data.descCompleta}</strong><br />
                          <span style={{ color, fontWeight: '600', fontSize: '14px' }}>{id}: {dineroDisabledMask(value)}</span>
                      </div>
                  )}
                  role="application"
              />
            </div>

            {/* TOTALES */}
            <div style={{ backgroundColor: "white", padding: 15, marginBottom: 10, height: "75px", borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)" }}>
              <Row>
                <Col span={5} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Piezas Vendidas</p>
                  <h1 style={{ fontSize: 15 }}>{this.state.piezasVendidas}</h1>
                </Col>
                <Col span={1} style={{ textAlign: "center" }}><h1 style={{ fontSize: 20 }}>|</h1></Col>
                
                <Col span={5} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Ingresos Totales</p>
                  <h1 style={{ fontSize: 15 }}>{dineroDisabledMask(this.state.ingresos)}</h1>
                </Col>
                
                {this.state.mostrarCostos && (
                    <>
                        <Col span={1} style={{ textAlign: "center" }}><h1 style={{ fontSize: 20 }}>-</h1></Col>
                        <Col span={5} style={{ textAlign: "center" }}>
                        <p style={{ margin: 0 }}>Costos Totales</p>
                        <h1 style={{ fontSize: 15 }}>{dineroDisabledMask(this.state.costos)}</h1>
                        </Col>
                        <Col span={1} style={{ textAlign: "center" }}><h1 style={{ fontSize: 20 }}>=</h1></Col>
                        <Col span={6} style={{ textAlign: "center" }}>
                        <p style={{ margin: 0 }}>Utilidad Neta</p>
                        <h1 style={{ fontSize: 15 }}>{dineroDisabledMask(this.state.utilidad)}</h1>
                        </Col>
                    </>
                )}
              </Row>
            </div>

            <TableItem
              rowKey={(value) => value._id.toString() + Math.random()}
              columns={columns}
              dataSource={this.state.todasInsumos}
              size="small"
              pagination={false}
            />
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ReporteInsumosMasVendidos);